module.exports = __webpack_public_path__ + "img/sem-imagem.ab417101.jpg";